import React from "react";
import "../../styles/pages/warehouse.css";
import { getPermissions } from "../../hooks/usePermissions";

interface Props {
  tab: string;
  onChange: (tab: string) => void;
}

const allTabs = [
  { id: "stock",     label: "Остатки" },
  { id: "receipts",  label: "Приход" },
  { id: "issues",    label: "Расход" },
  { id: "inventory", label: "Инвентаризация" },
  { id: "sales",     label: "Продажи" },
  { id: "movements", label: "Движения" },
  { id: "suppliers", label: "Поставщики" },
];

// Приход и поставщики содержат закупочные цены — только администратор и бухгалтер
const COST_TABS = ["receipts", "suppliers"];

export default function WarehouseTopBar({ tab, onChange }: Props) {
  const canSeeCost = getPermissions().canSeeCost;
  const tabs = allTabs.filter((t) => canSeeCost || !COST_TABS.includes(t.id));
  return (
    <div className="warehouse-topbar">
      {/* Десктоп — кнопки */}
      <div className="warehouse-segmented warehouse-tabs-desktop">
        {tabs.map((t) => (
          <button
            key={t.id}
            className={"warehouse-segment " + (tab === t.id ? "active" : "")}
            onClick={() => onChange(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Мобильный — выпадающий список */}
      <select
        className="warehouse-tabs-select"
        value={tab}
        onChange={(e) => onChange(e.target.value)}
      >
        {tabs.map((t) => (
          <option key={t.id} value={t.id}>{t.label}</option>
        ))}
      </select>
    </div>
  );
}
